import { useSelector } from "react-redux";

import ExportToHubSpotDropdownItem from "../../components/ExportToHubSpotDropdownItem/ExportToHubSpotDropdownItem";
import { selectHsIsNotIntegrated, selectHubspotContactsToggleState } from "../../store/selectors/hubspotSelectors";

type ContactsHubSpotExportItemContainerProps = {
    onClick(destination: string): void;
    tooltipDisabledContent?: string;
    isUseLockedIcon?: boolean;
    isExportDisabled?: boolean;
};

const ContactsHubSpotExportItemContainer = ({
    onClick,
    tooltipDisabledContent,
    isUseLockedIcon = true,
    isExportDisabled,
}: ContactsHubSpotExportItemContainerProps) => {
    const isHubspotNotIntegrated = useSelector(selectHsIsNotIntegrated);
    const isHubspotExportEnabled = useSelector(selectHubspotContactsToggleState);

    if (tooltipDisabledContent || isExportDisabled) {
        return (
            <ExportToHubSpotDropdownItem
                isExportEnabled={false}
                isUseLockedIcon={isUseLockedIcon}
                tooltipDisabledContent={tooltipDisabledContent}
                onClick={onClick}
            />
        );
    }
    if (isHubspotNotIntegrated) {
        return null;
    }

    return (
        <ExportToHubSpotDropdownItem
            isExportEnabled={isHubspotExportEnabled}
            isUseLockedIcon={isUseLockedIcon}
            onClick={onClick}
        />
    );
};

export default ContactsHubSpotExportItemContainer;
